export default __webpack_public_path__ + "static/media/wsbg.c242a8ea.jpg";